export default "__VITE_ASSET__dca78d30__"